import moment from "moment";
import { LoaderFunctionArgs, useLoaderData } from "react-router-dom";
import { useRef, useState } from "react";
import { ShowLayout } from "../../../layout/ShowLayout";
import {createApolloClient} from "../../../providers/ApolloClientFactory";
import ButtonGroup from "../../../components/Button";
import {generateReceipt} from "../../orders/actions/generate-new-receipt";
import {ShowRow} from "../../../components/ShowRow";
import {GET_ORDER_AHEAD_ORDER} from "./queries";
import {OrderAheadOrder, orderAheadStatusLabel} from "./orderAheadOrder";
import {ItemsTable} from "./orderShowComponents/ItemsTable";
import {TotalList} from "./orderShowComponents/Total";
import {RefundModal} from "./orderShowComponents/RefundModal";

const client = createApolloClient();

export const orderAheadOrderShowLoader = async ({ params }: LoaderFunctionArgs) => {
  const { id } = params;

  const { data } = await client.query({
    query: GET_ORDER_AHEAD_ORDER,
    variables: { id },
  });
  // orders_order_ahead has no array relationship to its transactions, so they are
  // fetched separately and merged onto the order for the Total/refund components.
  return {
    ...data.orders_order_ahead_by_pk,
    transactions: data.transactions_order_ahead,
  };
};

export const OrderAheadOrderShow = () => {
  const [generating, setGenerating] = useState(false);
  const [partial, setPartial] = useState(false);
  const refundButton = useRef<HTMLButtonElement>(null);
  const order = useLoaderData() as OrderAheadOrder;

  return (
      <>
        <ShowLayout
            header={`Order #${order.id}`}
            actions={
              <div className="flex space-x-2">
                <ButtonGroup
                    loading={generating}
                    mainButton={{
                      name: "Generate Receipt",
                      onClick: async () => {
                        setGenerating(true);
                        await generateReceipt(order.reference_id);
                        setGenerating(false);
                      },
                    }}
                    // Void = full refund; Refund = partial. Both open RefundModal,
                    // which calls the order-ahead refund action (ronin-api
                    // api/refund_order_ahead.js).
                    buttons={[
                      {
                        name: "Void",
                        onClick: () => {
                          refundButton.current?.click();
                        },
                      },
                      {
                        name: "Refund",
                        onClick: () => {
                          setPartial(true);
                          refundButton.current?.click();
                        },
                      },
                    ]}
                />
              </div>
            }
        >
          <ShowRow
              label="Tablet Transaction Time"
              value={moment(order.transaction_at).format("lll")}
          />
          <ShowRow
              label="Server Transaction Time"
              value={moment(order.created_at).format("lll")}
          />
          <ShowRow
              label="Last Updated Time"
              value={moment(order.updated_at).format("lll")}
          />
          <ShowRow label="Phone Number" value={order.phone_number} />
          <ShowRow
              label="Order Status"
              value={orderAheadStatusLabel(order.status)}
          />
          <ShowRow label="Reference ID" value={order.reference_id} />
          <ShowRow label="Processor Ref ID" value={order.processor_ref_id} />
          <ShowRow label="Event" value={order.event?.name} />
          <ShowRow label="Location" value={order.location?.name} />
          <ShowRow label="Vendor" value={order.vendor?.name} />
        </ShowLayout>
        <div className="mt-2">
          <ShowLayout header="Items">
            <ItemsTable items={order.items} />
          </ShowLayout>
        </div>
        <div className="mt-2">
          <TotalList />
        </div>
        <RefundModal partial={partial} onClose={() => setPartial(false)}>
          {({ setOpen }) => (
              <button ref={refundButton} onClick={() => setOpen(true)} />
          )}
        </RefundModal>
      </>
  );
};
